<template>
  <!-- 全局重新登录框：token 失效时强制登录恢复完整功能，不可跳过（可显式退出登录） -->
  <el-dialog
    :model-value="reloginState.visible"
    title="登录已过期"
    width="min(92vw, 400px)"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div class="relogin-tip">
      登录状态已失效，图片查看等功能暂不可用。请重新登录以恢复完整功能。
    </div>
    <el-form @submit.prevent>
      <el-form-item>
        <el-input v-model="username" placeholder="用户名 / 手机号" prefix-icon="User" />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="password"
          type="password"
          placeholder="密码"
          prefix-icon="Lock"
          show-password
          @keyup.enter="submit"
        />
      </el-form-item>
      <el-form-item v-if="reloginState.needTenant">
        <el-select v-model="tenantId" placeholder="请选择企业" style="width: 100%">
          <el-option
            v-for="t in reloginState.tenants"
            :key="t.tenantId"
            :label="t.tenantName"
            :value="t.tenantId"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div v-if="reloginState.error" class="relogin-error">{{ reloginState.error }}</div>
    <template #footer>
      <el-button link type="info" @click="giveUp">退出登录</el-button>
      <el-button type="primary" :loading="reloginState.loading" @click="submit">重新登录</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { useAuthStore } from '@/stores/auth'
import { reloginState, resolveRelogin } from '@/utils/sessionGuard'

const authStore = useAuthStore()
const username = ref('')
const password = ref('')
const tenantId = ref<number | undefined>(undefined)

// 弹窗每次打开时同步预填用户名、清空密码
watch(
  () => reloginState.visible,
  (v) => {
    if (v) {
      username.value = reloginState.username
      password.value = ''
      tenantId.value = undefined
    }
  }
)

const submit = async () => {
  if (!username.value.trim() || !password.value) {
    reloginState.error = '请输入用户名和密码'
    return
  }
  reloginState.loading = true
  reloginState.error = ''
  try {
    const res: any = await authStore.login(username.value.trim(), password.value, tenantId.value)
    // 多企业归属：后端要求先选企业
    if (res?.data?.needTenant) {
      reloginState.needTenant = true
      reloginState.tenants = res.data.tenants || []
      return
    }
    localStorage.setItem('lastUsername', username.value.trim())
    resolveRelogin(true)
    ElMessage.success('已重新登录')
  } catch (e: any) {
    reloginState.error = e?.response?.data?.message || e?.message || '登录失败，请重试'
  } finally {
    reloginState.loading = false
  }
}

const giveUp = () => {
  resolveRelogin(false)
  authStore.logout()
}
</script>

<style scoped>
.relogin-tip {
  font-size: 13px;
  color: var(--el-color-warning);
  margin-bottom: 12px;
  line-height: 1.5;
}
.relogin-error {
  font-size: 12px;
  color: var(--el-color-danger);
  margin-top: -8px;
}
</style>
